// Inspired from https://goenning.net/2016/05/13/how-i-manage-application-configuration-with-nodejs/
import _ from 'lodash';
import defaults from './defaults';
const configEnv = process.env.REACT_APP_ENV || 'development';
console.log('Config Env', configEnv);
const envOverrides = require(`./${configEnv}`);
const mergedConfigs = _.merge({}, defaults, envOverrides.default);
export default mergedConfigs;
